import { CreateComputedOptions, WritableSignal } from "@angular/core";
import { createComputed, SIGNAL, SignalGetter, signalSetFn, signalUpdateFn } from "@angular/core/primitives/signals";

export function computedWr<T>(computation: () => T, options?: CreateComputedOptions<T>): WritableSignal<T> {
    const getter = createComputed<T>(computation) as ReturnType<typeof createComputed<T>> & WritableSignal<T>;
    if (options?.equal)
        getter[SIGNAL].equal = options.equal;
    getter.toString = () => `[Computed: ${getter()}]`;
    getter.set = (value: T) => signalSetFn(getter[SIGNAL], value);
    getter.update = (updater: (value: T) => T) => signalUpdateFn(getter[SIGNAL], updater);
    return getter;
}

export function signalMarkAsDirty(...signals: WritableSignal<unknown>[]) {
    signals.forEach(signal => {
        const node = (signal as SignalGetter<unknown>)[SIGNAL];
        const eq = node.equal;
        node.equal = () => false;
        signal.update(x => x);
        node.equal = eq;
    });
}

export const ALWAYS_RECOMPUTE = { equal: () => false };